'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAdb = function MdAdb(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 15c0.9 0 1.6-0.7 1.6-1.6s-0.7-1.8-1.6-1.8-1.6 0.8-1.6 1.8 0.7 1.6 1.6 1.6z m-10 0c0.9 0 1.6-0.7 1.6-1.6s-0.7-1.8-1.6-1.8-1.6 0.8-1.6 1.8 0.7 1.6 1.6 1.6z m11.9-7.7c2.9 2.1 4.7 5.5 4.7 9.3v1.8h-23.2v-1.8c0-3.8 1.8-7.2 4.7-9.3l-3.5-3.6 1.4-1.3 3.8 3.9c1.6-0.8 3.3-1.3 5.2-1.3s3.6 0.5 5.2 1.3l3.8-3.9 1.4 1.4z m-18.5 19.3v-6.6h23.2v6.6c0 6.5-5.1 11.8-11.6 11.8s-11.6-5.3-11.6-11.8z' })
        )
    );
};

exports.default = MdAdb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/adb.js
// module id = 2779
// module chunks = 0